import styled from "styled-components";
import { Skeleton } from "@material-ui/lab";
import { FiImage } from "react-icons/fi";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
export const ImageContent = styled.div`
  width: 100%;
  height: 80%;
  margin-top: 8px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FooterContainer = styled.div`
  width: 80%;
  height: 45%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FooterImage = styled.div`
  height: 80%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FakeImage = styled(Skeleton)`
  width: 350px;
  height: 350px;
`;

export const Preview = styled.div`
  width: 100%;
  height: 100%;

  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  background-size: contain;

  margin: 10px;
  object-fit: fill;
`;

export const MinPreview = styled.div`
  margin: 0px;
  min-width: 70px;
  min-height: 70px;
  margin-right: 5px;
  border-radius: 15px;

  ${(props) =>
    props.selected &&
    `
      border-width: 5px;
      border: solid;
      border-color: var(--secondary);
    `}

  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;

  cursor: pointer;

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-end;

  :hover .remove-image {
    display: flex;
  }

  .remove-image {
    display: none;
  }
`;

export const AddNewImage = styled.label`
  margin: 0px 12px;
  min-width: 70px;
  min-height: 70px;
  margin-right: 5px;

  border-radius: 15px;
  border: 1px solid;
  border-color: #999;

  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: transparent;
`;

export const ListPreview = styled.div`
  height: 60%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 6px !important;
    height: 6px !important;
  }
  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.3);
  }
  ::-webkit-scrollbar-track {
    background: hsla(0, 0%, 100%, 0.1);
  }
`;

export const Actions = styled.div`
  margin-right: 170px;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .MuiBadge-badge {
    border-radius: 50%;
    width: 35px;
    height: 35px;
    font-size: 18px;
    top: 10%;
    right: 5%;
  }
`;

export const ImageButton = styled.label`
  background: #d2386d;
  height: 46px;
  width: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  border-radius: 50%;
  cursor: pointer;

  transition: filter 0.5s;

  &:hover {
    filter: brightness(1.1);
  }
`;

export const ImageIcon = styled(FiImage).attrs({
  size: 22,
})`
  color: #ffffff;
`;
